/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_IC_73_67 as Componente_IC_73_67,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_RC_82_67(e, t) {
  return (
    <li
      key={t}
      className={`flex flex-col gap-2 rounded-2xl border border-(--border) p-3`}
      children={[
        <div
          className={`flex items-center gap-2`}
          children={[
            <Componente_IC_73_67 ancho={`w-1/2`} alto={`h-4`} />,
            <div
              className={`ml-auto flex gap-1.5`}
              children={[
                <Componente_IC_73_67 ancho={`w-16`} />,
                <Componente_IC_73_67 ancho={`w-20`} />,
              ]}
            />,
          ]}
        />,
        <Componente_IC_73_67 ancho={`w-1/3`} alto={`h-2.5`} />,
      ]}
    />
  );
}
